module.exports = __webpack_public_path__ + "img/qr_transvie.e89f9579.jpg";